import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

@Component({
	selector: 'cass-ck-text-editor',
	templateUrl: './ck-text-editor.component.html',
	styleUrls: ['./ck-text-editor.component.css']
})
export class CkTextEditorComponent implements OnInit, AfterViewInit, OnDestroy {

	// External interface
	@Input()
	initialContent: string | undefined;

	@Output()
	contentChanged = new EventEmitter<string | undefined>();

	// Note: CKEditor 4 has two bugs in onChange events:
	// - sometimes it does not return the last char
	// - it does not return updated text when font size is changed
	// so the only working way of getting updated text out of CKEditor is editorInstance.dataChange.subscribe

	@ViewChild("ckEditorInstance")
	editorInstance: any;

	constructor() { }

	ckeditorUrl: string = "./lib/ckeditor/ckeditor.js";

	content: any = "";

	config: any;

	private editorDataChangeSubscriber: any = undefined;

	ngOnInit(): void {
		this.config =
		{
			"removePlugins": "save,elementspath",
			"extraPlugins": "wordcount,resize",
			"font_names": "avenir;showcard gothic;gill sans mt",
			"fontSize_sizes": "8px;10px;12px;14px;16px",
			"toolbar": [
				[
					"Cut",
					"Copy",
					"-",
					"Paste",
					"PasteText",
					"-",
					"SelectAll",
					"-",
					"Undo",
					"Redo"
				],
				[
					"Bold",
					"Italic",
					"Underline",
					"Superscript"
				],
				[
					"SpecialChar",
					"Smiley"
				],
				[
					"Font",
					"FontSize"
				]
			]
		}

		this.content = this.initialContent;
	}

	ngAfterViewInit() {
		this.editorDataChangeSubscriber = this.editorInstance.dataChange.subscribe((value: any) => {
			this.contentChanged.emit(String(value));
		});
	}

	ngOnDestroy() {
		if (this.editorDataChangeSubscriber) {
			if (this.editorDataChangeSubscriber.unsubscribe) {
				this.editorDataChangeSubscriber.unsubscribe();
			}
			this.editorDataChangeSubscriber = undefined;
		}
	}
}
